import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Image = () => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { regex: "/step3.png/" }) {
          childImageSharp {
            fluid(maxWidth: 1400, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Img className="" alt="Step 3: Download trailers as needed, or subscribe to a title to automatically receive trailers as they become available" fluid={data.file.childImageSharp.fluid} />
    )}
  />
)

export default Image
